import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getCheckLinks } from '../utils/urls';

import { ValidatedLinkOutput } from 'types/accounts';
import { ErrorModal } from 'types/modalTypes';

async function fetchCheckLinks({
  accountId,
  formId,
}: TVariables): Promise<TResult> {
  const response = await fetch(getCheckLinks(accountId, formId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<ValidatedLinkOutput>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: string | null;
  formId: string | null;
};

function useGetCheckLinks(
  page: number,
  accountId: string | null,
  formId: string | null,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_check_links_list', accountId, formId],
    () => fetchCheckLinks({ accountId, formId }),
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetCheckLinks };
